import { OpenDateNotReached } from '../result/open-date-not-reached';
import { IPickPreCheckError, PreCheckErrorMixin } from './pre-check-error';

export class OpenDateNotReachedPreCheckError extends PreCheckErrorMixin(OpenDateNotReached) implements IPickPreCheckError {
    constructor(pickId: string, date: Date) {
        super(pickId, date);
    }

    override readonly openDate: Date;
}
